"use client";

import { ShieldCheck, FileText, Globe } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RegulatorycomplianceCompliance() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const features = [{
    icon: Globe,
    title: "Product Evaluation",
    description: "We evaluate healthcare technologies based on clinical value, market potential, and long-term partnership opportunities."
  }, {
    icon: FileText,
    title: "Market Access Assessment\n",
    description: "We provide preliminary market access assessments that help partners understand international market requirements."
  }, {
    icon: ShieldCheck,
    title: "Strategic Distribution",
    description: "Through strategic distribution and international business development, we help partners expand into global healthcare markets with confidence."
  }];
  return <section data-section-id="220" id="regulatorycompliance" className="relative overflow-hidden bg-white py-24 md:py-32 lg:py-40">
      <div aria-hidden="true" className="pointer-events-none absolute -left-32 top-1/4 h-[600px] w-[600px] bg-slate-50 opacity-70 blur-3xl" style={{
      borderRadius: "60% 40% 55% 45% / 50% 60% 40% 50%"
    }} />
      <div aria-hidden="true" className="pointer-events-none absolute -right-40 bottom-0 h-[500px] w-[500px] bg-slate-50 opacity-60 blur-3xl" style={{
      borderRadius: "45% 55% 40% 60% / 55% 45% 60% 40%"
    }} />

      <div className="relative mx-auto max-w-7xl px-6 md:px-10">
        <div ref={headerRef} className={`mx-auto max-w-[900px] text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-default text-sm uppercase tracking-[0.15em] text-teal-600">
            Our Commitment
          </p>
          <h1 className="font-default mt-8 text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.1] tracking-tighter text-slate-900">
            Global Medical{" "}
            <em className="italic font-light text-blue-600">Sourcing</em>
            <br className="hidden sm:block" /> and Distribution{" "}
            <em className="italic font-light text-blue-600">Excellence</em>
          </h1>

          <div className="mt-12 flex items-center justify-center gap-4">
            <span className="h-px w-12 bg-slate-200/60" />
            <span className="h-1.5 w-1.5 rounded-lg bg-blue-600" />
            <span className="h-px w-12 bg-slate-200/60" />
          </div>
        </div>

        <div ref={gridRef} className="relative mt-24 md:mt-32 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-12">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className={`group relative flex flex-col items-center text-center px-6 py-8 rounded-2xl transition-all duration-500 ease-out hover:shadow-lg hover:bg-slate-50/50 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: gridVisible ? `${i * 180}ms` : "0ms"
          }}>
                {i > 0 && <span aria-hidden="true" className="hidden md:block absolute left-0 top-12 bottom-12 w-px bg-slate-200/40" />}

                <div className="relative mb-6 flex h-20 w-20 items-center justify-center">
                  <span aria-hidden="true" className="absolute inset-0 rounded-lg border border-blue-600/20 transition-colors duration-300 group-hover:border-blue-600/50" style={{
                borderRadius: "55% 45% 50% 50% / 50% 55% 45% 50%"
              }} />
                  <Icon strokeWidth={1} className="h-10 w-10 text-blue-600" />
                </div>

                <h3 className="font-default text-xl md:text-2xl leading-[1.3] text-slate-900 mt-6">
                  {feature.title}
                </h3>
                <p className="font-default mt-4 max-w-xs text-base leading-[1.7] text-slate-600">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}